import React from 'react';
import { Route } from 'react-router-dom';

import OrderNewNumber from './twilio/order-new-number/order-new-number.component';
import PurchaseFaxNumber from './twilio/purchase-fax-number/purchase-fax-number.component';
import { Device } from './devices/device.component';
import { Devices } from './devices/devices.component';
import { CallSettingsContainer } from './call-settings-container/call-settings.container';
import { FaxSettings } from './fax-settings-container/fax-settings/fax-settings.component';
import { VoiceMailboxes } from './voice-mailboxes/voice-mailboxes.component';
import { PHONES } from '../../constants/paths';
import { Phone404 } from './phone-404.component';
import { TenantMigration } from './tenant-migration/tenant-migration.component';
import { UserMobileSupport } from '../users/user-mobile-support.component';
import { CrawlSwitch } from '../../routers/crawl-switch';
import { Deunification } from './deunification/deunification.component';

export const PhoneRouter = () => {
  return (
    <CrawlSwitch>
      <Route exact path={PHONES.devices} component={Devices} />
      <Route path={PHONES.device} component={Device} />
      <Route path={PHONES.callSettings} component={CallSettingsContainer} />
      <Route path={PHONES.faxSettings} component={FaxSettings} />
      <Route path={PHONES.orderNewNmber} component={OrderNewNumber} />
      <Route path={PHONES.purchaseFaxNumber} component={PurchaseFaxNumber} />
      <Route path={PHONES.voiceMailboxes} component={VoiceMailboxes} />
      <Route path={PHONES.tenantMigration} component={TenantMigration} />
      <Route path={PHONES.deunification} component={Deunification} />
      <Route path={PHONES.userMobileSupport} component={UserMobileSupport} />
      <Route path={PHONES.root} component={Phone404} />
    </CrawlSwitch>
  );
};
